import { render, staticRenderFns } from "./RateReceivableTableOperation.vue?vue&type=template&id=2650c510&"
import script from "./RateReceivableTableOperation.vue?vue&type=script&lang=js&"
export * from "./RateReceivableTableOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports